import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSRegraService from '@/services/SistemaDKP/SLSRegra.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSRegraService = new SLSRegraService();
  const refRegraListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // {key: 'regraid', label: 'Codigo', sortable: false},
    { key: 'tipo_regra', label: 'Tipo', sortable: true },
    { key: 'nome_regra', label: 'Nome', sortable: true },
    { key: 'versao_regra', label: 'Versão', sortable: true },
    // {key: 'created_at', label: 'Data Criação', sortable: true},
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalRegra = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refRegraListTable.value ? refRegraListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRegra.value,
    };
  });

  const refetchData = () => {
    refRegraListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchRegra = (ctx, callback) => {
    overlay.value = true;
    sLSRegraService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalRegra.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching regras list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      const response = await sLSRegraService.store(body);

      if (response || (response.status >= 200 && response.status < 300)) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Regra cadastrada com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        refetchData();
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Regra não foi cadastrada.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    } catch (error) {
      console.error('Erro ao cadastrar Regra.');
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao cadastrar Regra.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };
  const Updated = async (body) => {
    await sLSRegraService.update(body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSRegraService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchRegra,
    tableColumns,
    perPage,
    currentPage,
    totalRegra,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refRegraListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
